import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/common/components/shared.module";
import { PrivacyEducationAsideComponent } from "../privacy-education-aside/privacy-education-aside.component";
import { UiCardModule } from "src/app/common/components/ui/ui-card/ui-card.module";
import { DirectivesModule } from "src/app/common/components/directives.module";

@NgModule({
    declarations: [
        PrivacyEducationAsideComponent
    ],
    imports: [
        UiCardModule,
        SharedModule,
        DirectivesModule
        
    ],
    exports: [PrivacyEducationAsideComponent]
})

export class PrivacyEducationAsideModule { }
